import { ContentLoader } from 'components/design-system/ContentLoader';

export const OrderStatusLoaderContent = () => (
  <>
    <div className='d-flex w-100 align-items-center justify-content-between fs-14px mb-4 border-bottom border-top py-3'>
      <div>
        <ContentLoader width={150} />
        <ContentLoader width={65} />
      </div>
      <div>
        <ContentLoader width={80} height={80} borderRadius={20} />
      </div>
    </div>
    <ContentLoader width={65} />
    <div className='mt-3' />
    <ContentLoader height={71} borderRadius={20} />
    <div className='mt-3' />
    <ContentLoader width={65} />
    <div className='mt-3' />
    {[1, 2, 3].map(key => (
      <div key={key} className='d-flex justify-content-between mt-1'>
        <ContentLoader width={120} />
        <ContentLoader className='' width={60} />
      </div>
    ))}
  </>
);

export const OrderStatusLoaderTitle = () => (
  <div className='text-center riforma-regular gap-2'>
    <div className='fs-18px'>Order details</div>
    <div className='fs-14px text-secondary'>
      Order #<ContentLoader className='' width={45} />
    </div>
  </div>
);
